import { defineAction } from '~/prix'
import { z } from 'zod'
import protocolReportAction from './protocolReport.action.json' with { type: 'json' }
import { reportFormatSchema } from '~/utils/server/report'

const protocolReportDefinition = defineAction({
  ...protocolReportAction,

  input: z.object({
    id: z.string().uuid(),
    format: reportFormatSchema.default('pdf'),
  }),
  output: z.any(),
})

export default protocolReportDefinition
